import { createStyles, Select, SelectProps } from "@mantine/core";
import React from "react";
import { IconV2 } from "../..";

interface RpiDropdownProps {
  fullWidth?: boolean;
}

const useRpiDropdownStyles = createStyles<"root" | "input" | "rightSection" | "dropdown" | "item", RpiDropdownProps>(
  (theme, { fullWidth }) => ({
    root: {
      width: fullWidth ? "100%" : 269,
    },
    input: {
      ...theme.other.fontTypes.p3,
      fontWeight: theme.other.fontWeights.regular,
      lineHeight: "1rem",
      color: `${theme.colors.brand[5]} !important`,
      padding: "16px 24px",
      paddingRight: 36,
      borderRadius: "25px",
      outline: "none",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.calm[5],
      height: 50,
      textOverflow: "ellipsis !important",
      "&::placeholder": {
        color: `${theme.colors.brand[5]} !important`,
        fontWeight: theme.other.fontWeights.light,
        opacity: 1,
      },

      "&:focus, &:active": {
        borderColor: theme.colors.amethyst[5],
      },
    },
    rightSection: {
      color: theme.colors.brand[5],
      pointerEvents: "none",
      paddingRight: 24,
    },
    dropdown: {
      borderRadius: "12px",
      marginTop: -5,
      border: "none",
    },
    itemsWrapper: {
      padding: 3,
      gap: 3,
    },
    item: {
      ...theme.other.fontTypes.button,
      lineHeight: "16px",
      color: theme.colors.brand[5],
      minHeight: 32,
      height: "fit-content",
      display: "flex",
      alignItems: "center",
      borderRadius: 8,
      padding: "7.5px 24px",
      "&[data-selected]": {
        "&, &:hover": {
          color: theme.colors.brand[5],
          backgroundColor: theme.colors.calm[4],
        },
      },
      "&[data-hovered]": {
        color: theme.colors.brand[5],
        backgroundColor: theme.colors.calm[4],
      },
    },
    error: {
      ...theme.other.fontTypes.label,
      fontWeight: theme.other.fontWeights.regular,
      color: theme.colors.spark[6],
      marginLeft: 26,
      marginRight: 26,
      lineHeight: "unset",
      marginTop: 6,
    },
    invalid: {
      borderColor: theme.colors.spark[6],
    },
  })
);

// TODO: Icon rotation
export const RpiDropdown = React.forwardRef<HTMLInputElement, Omit<SelectProps, "classNames"> & RpiDropdownProps>(
  ({ fullWidth, ...props }, ref) => {
    const { classes } = useRpiDropdownStyles({ fullWidth });

    return (
      <Select
        ref={ref}
        classNames={classes}
        rightSection={<IconV2.ArrowDown width={10} height={16} color="currentColor" />}
        {...props}
      />
    );
  }
);
